import { Button, PageHeader } from 'antd'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  isInsert: string | null
}

const ImportCustomersPageHeader: FC<Props> = ({ isInsert }) => {
  const { t } = useTranslation()
  return (
    <PageHeader
      // eslint-disable-next-line react/jsx-key
      extra={[<Button key={'download'}>{t('components.pages.customers.imports.pageHeader.download')}</Button>]}
      ghost={false}
      title={
        isInsert === 'true'
          ? t('components.pages.employees.imports.pageHeader.importInsert')
          : t('components.pages.employees.imports.pageHeader.importOverWrite')
      }
    />
  )
}

ImportCustomersPageHeader.displayName = 'ImportCustomersPageHeader'
export default ImportCustomersPageHeader
